// src/rtkQuery/modules/questionnaire/questionnaireApi.ts
import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { QUESTIONNAIRE_ENDPOINTS } from '@/rtkQuery/config/questionnairesApi.config';
import { buildQuery } from '@/rtkQuery/lib';
import type { HealthQuestionnaireResponse, NewPatientQuestionnaireResponse, SubmitHealthQuestionnaireRequest, SubmitHealthQuestionnaireResponse } from '../../models/questionnaires.model';

const questionnairesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNewPatientQuestionnaire: builder.query<NewPatientQuestionnaireResponse, void>({
            query: buildQuery(QUESTIONNAIRE_ENDPOINTS.NEW_PATIENT_QUESTIONNAIRE, 'GET'),
            transformResponse: (response: NewPatientQuestionnaireResponse, meta) => {
                (meta as any).status = 'success';
                (meta as any).error = null;
                return response;
            },
            transformErrorResponse: (response: any, meta) => {
                const errorMessage = response.data?.message || 'Failed to fetch questionnaire';
                (meta as any).status = 'error';
                (meta as any).error = errorMessage;

                return {
                    status: response.status,
                    message: errorMessage,
                    errors: response.data?.errors || {},
                };
            },
            providesTags: ['Questionnaires'],
        }),

        getHealthQuestionnaire: builder.query<HealthQuestionnaireResponse, void>({
            query: buildQuery(QUESTIONNAIRE_ENDPOINTS.HEALTH_QUESTIONNAIRE, 'GET'),
            transformResponse: (response: HealthQuestionnaireResponse, meta) => {
                (meta as any).status = 'success';
                (meta as any).error = null;
                return response;
            },
            transformErrorResponse: (response: any, meta) => {
                const errorMessage = response.data?.message || 'Failed to fetch health questionnaire';
                (meta as any).status = 'error';
                (meta as any).error = errorMessage;

                return {
                    status: response.status,
                    message: errorMessage,
                    errors: response.data?.errors || {},
                };
            },
            providesTags: ['Questionnaires'],
        }),
        submitHealthQuestionnaire: builder.mutation<SubmitHealthQuestionnaireResponse, SubmitHealthQuestionnaireRequest>({
            query: buildQuery(QUESTIONNAIRE_ENDPOINTS.SUBMIT_HEALTH_QUESTIONNAIRE, 'POST'),
            invalidatesTags: ['Questionnaires'],
        }),
    }),

    overrideExisting: false,
});

export const {
    useGetNewPatientQuestionnaireQuery,
    useLazyGetNewPatientQuestionnaireQuery,
    useGetHealthQuestionnaireQuery,
    useLazyGetHealthQuestionnaireQuery,
    useSubmitHealthQuestionnaireMutation
} = questionnairesApi;
